import React from 'react';
import { Loader, Texture, TextStyle } from 'pixi.js'
import { Sprite, Container, Stage, Text } from '@inlet/react-pixi'
import { ease } from 'pixi-ease'
import {
    Dialog,
    DialogContent,
    CardContent,
    Typography,
    AccordionSummary,
    Grid,
    Button,
    Hidden
} from '@material-ui/core';

import useStyles from '../../../styles/components/survey/stylesSurvey';
import { StudentProfile } from '../../../utils/services/cache/ClientCache'

const domElement = document.querySelector('#root');
let initWidth = domElement.offsetWidth;
let initHeight = domElement.offsetHeight;

const FlyingCoinAnimationModal = ({ _isOpen, _notiCloseClick, _extraContent }) => {
    let currentRewardPoint = StudentProfile.getRewardPoint();
    const classes = useStyles()
    const coin1 = React.useRef();
    const coin2 = React.useRef();
    const coin3 = React.useRef();
    const walletText = React.useRef();
    const mainContainer = React.useRef();
    const btnId = React.useRef();

    if (initWidth < 2000) {
        initWidth = 1920;
        initHeight = 900;
    }

    let boxInitX = (initWidth - 560) / 2;
    let boxInitY = (initHeight - 250) / 2;

    const titleStyle = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 24,
        fill: "white",
        wordWrap: true,
        wordWrapWidth: 250,
        align: "center",

    });

    const titleStyle2 = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 18,
        fill: "black",
        wordWrap: true,
        wordWrapWidth: 450,
        align: "center",
    });

    let coinTexture = Texture.from(`./assets/images/components/island/particle/coin.png`);
    let alertTexture = Texture.from(`./assets/images/components/island/particle/alert_box.png`);
    let transparentTexture = Texture.from(`./assets/images/components/island/particle/transparentBG.png`);
    let awesomeBtn = Texture.from(`./assets/images/components/island/particle/awesome.png`);

    const animateToTop = () => {
        if (coin1.current !== null && coin1.current !== undefined) {
            btnId.current.buttonMode = btnId.current.interactive = btnId.current.visible = false;
            coin1.current.visible = coin2.current.visible = coin3.current.visible = true;
            ease.add(coin1.current, { position: { x: boxInitX + 260, y: 2 } }, { reverse: false, duration: 1000 })
            ease.add(coin2.current, { position: { x: boxInitX + 260, y: 2 } }, { reverse: false, duration: 1500 })
            const example3 = ease.add(coin3.current, { position: { x: boxInitX + 260, y: 2 } }, { reverse: false, duration: 2000 })
            example3.once('complete', () => {
                if (coin1.current !== null && coin1.current !== undefined) {
                    coin1.current.visible = coin2.current.visible = coin3.current.visible = false;
                    walletText.current.text = parseInt(currentRewardPoint) + parseInt(_extraContent.rewardPoint);
                    const example4 = ease.add(mainContainer.current, { alpha: 0 }, { reverse: false, duration: 1000 })
                    example4.once('complete', () => {
                        if (mainContainer.current !== null && mainContainer.current !== undefined) {
                            mainContainer.current.visible = false;
                            _notiCloseClick();
                        }
                    })
                }
            })
        }
    }

    //throw new Error('CABOOM');

    return (
        <>
            {
                _isOpen ?
                    <>
                        <Hidden smDown>
                            <div className="adventurelearn_flyingCoinAnimationHolder">

                                <Stage width={initWidth} height={initHeight} options={{ transparent: true }}>
                                    <Container ref={mainContainer}>
                                        <Container>
                                            <Sprite width={initWidth} height={initHeight} texture={transparentTexture} interactive={true} />
                                        </Container>
                                        <Container x={boxInitX} y={boxInitY}>
                                            <Sprite
                                                texture={alertTexture}
                                            />
                                            <Sprite
                                                scale={{ x: 0.6, y: 0.6 }}
                                                x={260}
                                                y={20}
                                                texture={coinTexture}
                                            />
                                            {
                                                _extraContent != null ?

                                                    _extraContent.message && _extraContent.message.length > 0 ?
                                                        <Text
                                                            text={_extraContent.message}
                                                            x={80}
                                                            y={95}
                                                            style={titleStyle2}
                                                        />
                                                        :
                                                        <Text
                                                            text={`You\'ve obtained ${_extraContent.rewardPoint} coins!`}
                                                            x={170}
                                                            y={95}
                                                            style={titleStyle2}
                                                        />
                                                    : <></>
                                            }

                                            <Sprite
                                                ref={btnId}
                                                texture={awesomeBtn}
                                                x={200}
                                                y={155}
                                                scale={{ x: 1, y: 1 }}
                                                interactive={true} buttonMode={true}
                                                pointerdown={() => {
                                                    animateToTop()
                                                }}
                                            />
                                        </Container>
                                        <>
                                            <Sprite
                                                visible={false}
                                                ref={coin1}
                                                texture={coinTexture}
                                                x={boxInitX + 260}
                                                y={boxInitY + 50}
                                                scale={{ x: 0.6, y: 0.6 }}
                                            />
                                            <Sprite
                                                visible={false}
                                                ref={coin2}
                                                texture={coinTexture}
                                                x={boxInitX + 260}
                                                y={boxInitY + 50}
                                                scale={{ x: 0.6, y: 0.6 }}
                                            />
                                            <Sprite
                                                visible={false}
                                                ref={coin3}
                                                texture={coinTexture}
                                                x={boxInitX + 260}
                                                y={boxInitY + 50}
                                                scale={{ x: 0.6, y: 0.6 }}
                                            />
                                            <Container x={boxInitX + 260} y={2}>
                                                <Sprite
                                                    scale={{ x: 0.6, y: 0.6 }}
                                                    texture={coinTexture}
                                                />
                                                <Text ref={walletText}
                                                    text={currentRewardPoint}
                                                    x={70}
                                                    y={20}
                                                    style={titleStyle}
                                                />
                                            </Container>
                                        </>
                                    </Container>
                                </Stage>

                            </div>
                        </Hidden>
                        <Hidden mdUp>
                            <Dialog
                                classes={{ paperWidthFalse: classes.paperWidthFalse }}
                                fullWidth={true}
                                maxWidth={false}
                                open={true}>
                                <DialogContent classes={{ root: classes.rootDialogContent }}>

                                    <CardContent classes={{ root: classes.rootCard }}>
                                        <Grid
                                            container
                                            direction="column"
                                            justify="center"
                                            alignItems="center">

                                            <AccordionSummary>
                                                <Grid
                                                    container
                                                    direction="column"
                                                    justify="center"
                                                    alignItems="center">
                                                    <Typography className="adventurelearn__header">

                                                        {
                                                            _extraContent != null ?
                                                                _extraContent.message && _extraContent.message.length > 0 ?
                                                                    _extraContent.message
                                                                    :`You've obtained ${_extraContent.rewardPoint} coins!`
                                                                : ""
                                                        }
                                                    </Typography>
                                                </Grid>
                                            </AccordionSummary>

                                            <Button
                                                onClick={() => _notiCloseClick()}
                                                classes={{ root: classes.rootButtonDialog }}>
                                                Awesome
                                             </Button>

                                        </Grid>
                                    </CardContent>

                                </DialogContent>
                            </Dialog>
                        </Hidden>
                    </>
                    :
                    <></>
            }
        </>
    );
}

export { FlyingCoinAnimationModal as default }